import React from "react";
import { connect } from "react-redux";
import { Form, Icon, Input, Select } from "antd";
import { withNamespaces } from "react-i18next";
import {
  getAllowRecordingConsentByUserId,
  getRequirePassword,
  getPrerandomizationConsentStatus,
  getLimitConsentToSubjectSiteStatus,
} from "../../reducers/user/selectors";

const { Option } = Select;

const ConsentFormStep1Component = (props) => {
  if (props.currentStep !== "Step 1") {
    return null;
  }

  return (
    <div className="form-group">
      <input
        name="username"
        style={{ opacity: 0, position: "absolute" }}
        tabIndex="-1"
      />
      <input
        type="password"
        style={{ opacity: 0, position: "absolute" }}
        tabIndex="-1"
      />

      {(!props.limitConsentToSubjectSiteStatus || (props.getPrerandomizationConsentStatus && props.limitConsentToSubjectSiteStatus && props.consentRandomization)) && <Form.Item>
        {props.getFieldDecorator("siteID", {
          initialValue: props.siteID ? props.siteID : undefined,
          onChange: (value) => {
            props.handleChange({ target: { name: "siteID", value } });
          },
          rules: [
            {
              required: true,
              message: props.i18n.t("Please select site id"),
            },
          ],
        })(
          <Select
            size="large"
            placeholder={props.i18n.t("Select Site ID")}
            style={{ width: "100%" }}
            showSearch
            optionFilterProp="children"
            filterOption
          >
            {props.sites
              .filter((site) => site.site_type === "randomization")
              .sort(
                (a, b) =>
                  +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
              )
              .map((site) => (
                <Option key={site.code} value={site.code}>
                  {site.code} - {site.name}
                </Option>
              ))}
          </Select>
        )}
      </Form.Item>}

      {props.getAllowRecordingConsentByUserId && (
        <Form.Item>
          {props.getFieldDecorator("userID", {
            initialValue: props.userID,
            onChange: props.handleChange,
            rules: [
              {
                required: true,
                message: props.i18n.t("Please input user id"),
              },
            ],
          })(
            <Input
              autoComplete="nope"
              prefix={<Icon type="skin" style={{ color: "#000" }} />}
              id="userID"
              name="userID"
              placeholder={props.i18n.t("User ID")}
              allowClear
              size="large"
            />
          )}
        </Form.Item>
      )}

      {!props.consentRandomization && (
        <Form.Item>
          {props.getFieldDecorator("subjectID", {
            initialValue: props.subjectID,
            onChange: props.handleChange,
            rules: [
              {
                required: true,
                message: props.i18n.t("Please input subject id"),
              },
            ],
          })(
            <Input
              autoComplete="off"
              prefix={<Icon type="user" style={{ color: "#000" }} />}
              id="subjectID"
              name="subjectID"
              placeholder={props.i18n.t("Subject ID")}
              allowClear
              size="large"
            />
          )}
        </Form.Item>
      )}

      {props.getRequirePassword && (
        <Form.Item>
          {props.getFieldDecorator("password", {
            onChange: props.handleChange,
            rules: [
              {
                required: true,
                message: props.i18n.t("Password"),
              },
            ],
          })(
            <Input.Password
              autoComplete="nope"
              id="password"
              name="password"
              placeholder={props.i18n.t("Password")}
              allowClear
              size="large"
            />
          )}
        </Form.Item>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  getAllowRecordingConsentByUserId: getAllowRecordingConsentByUserId(state),
  getRequirePassword: getRequirePassword(state),
  limitConsentToSubjectSiteStatus: getLimitConsentToSubjectSiteStatus(state),
  getPrerandomizationConsentStatus: getPrerandomizationConsentStatus(state),
});

export const ConsentFormStep1 = connect(mapStateToProps)(
  withNamespaces()(ConsentFormStep1Component)
);



// WEBPACK FOOTER //
// ./src/components/Consent/ConsentStep1.js